var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25629_5230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9592 19.3818C15.7035 19.3818 11.6928 20.0078 8.36072 21.1921C7.5382 21.4844 6.68197 21.6328 5.81602 21.6327C4.74815 21.6327 3.71339 21.4049 2.76892 20.9854C3.54472 23.87 6.18714 26 9.31917 26H24.8109C27.975 26 30.6398 23.8261 31.3847 20.8964C31.0829 20.8954 30.7828 20.8536 30.4925 20.7714C27.2797 19.8624 23.6373 19.3818 19.9592 19.3818Z",
    fill: "#FF7010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5413 18.2524C11.8704 17.929 13.26 17.6777 14.6871 17.5004C11.9049 14.4597 11.6457 9.3412 14.1837 6C12.1402 6.06286 10.1451 6.39693 8.28753 6.97437C7.33578 7.88611 6.66037 9.06045 6.35967 10.3514C5.54679 13.5583 7.44337 17.1184 10.5413 18.2524Z",
    fill: "#FF7010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60386 19.1221C4.82169 17.0409 3.3729 13.4435 4.20934 9.85267C4.31487 9.39963 4.45712 8.95812 4.62984 8.53027C3.8926 8.94175 3.19658 9.39948 2.55082 9.90158C-1.4576 12.9999 0.824821 19.4418 5.81605 19.4297C6.41007 19.4297 7.01367 19.3298 7.60386 19.1221Z",
    fill: "#FF7010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4456 9.22607C25.4726 9.70452 24.688 10.4897 24.2114 11.4733C23.41 13.127 23.6105 15.0496 24.6766 16.487C24.8414 16.7092 25.4471 17.3774 25.5034 17.529C27.4269 17.774 29.3099 18.147 31.095 18.6521C31.4659 18.7571 31.8652 18.6612 32.1477 18.3991C32.4303 18.137 32.5551 17.7466 32.4772 17.3696C31.8028 14.1095 29.5905 11.259 26.4456 9.22607Z",
    fill: "#FF7010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6896 17.2381C19.293 17.1552 20.9196 17.1612 22.538 17.2552C21.3139 15.2415 21.1577 12.7143 22.2239 10.5142C22.7036 9.52423 23.3985 8.67316 24.2499 8.01215C22.1113 7.00796 19.6783 6.33791 17.0857 6.09277C13.577 8.98109 13.9069 14.7692 17.6896 17.2381Z",
    fill: "#FF7010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25629_5230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/Sushi.217c1887aa6a5472698fe5178e6004e3.svg";
export { ForwardRef as ReactComponent };